import { useEffect, useState } from "react";
import { History, FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { fileUrl } from "@/lib/upload";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export const RulesVersions = ({ contestId, refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.rulesVersions(contestId).then(setD).catch(() => {}); }, [contestId, refreshKey]);
  if (!d) return null;
  return (
    <div className="rounded-lg border border-border p-3 space-y-2" data-testid="rules-versions">
      <div className="flex items-center gap-2 text-sm font-semibold"><History className="h-4 w-4 text-violet-400" /> Cronologia versioni
        <Badge variant="outline" className="border-border ml-auto" data-testid="rules-current-version">Versione attuale: {d.current.version} · {d.current.accepted_plays} accettazioni</Badge>
      </div>
      <p className="text-[11px] text-muted-foreground">Ogni modifica al testo o al PDF crea una nuova versione: a tutti i giocatori verrà richiesta di nuovo l'accettazione e i clienti registrati vengono avvisati via email e WhatsApp.</p>
      {d.history.length === 0 ? <p className="text-xs text-muted-foreground">Nessuna versione precedente</p> : (
        <ul className="space-y-1.5">
          {d.history.map((v) => (
            <li key={v.version} className="text-xs rounded-md bg-secondary/40 p-2" data-testid={`rules-version-${v.version}`}>
              <div className="flex items-center gap-2"><span className="font-semibold">v{v.version}</span><span className="text-muted-foreground">valida fino al {fmt(v.valid_until)} · sostituita da {v.replaced_by}</span><span className="ml-auto">{v.accepted_plays} accettazioni</span></div>
              {v.rules_file_id && <a className="inline-flex items-center gap-1 text-primary underline mt-1" href={fileUrl(v.rules_file_id)} target="_blank" rel="noreferrer"><FileText className="h-3 w-3" /> PDF v{v.version}</a>}
              {v.rules_text && <details className="mt-1"><summary className="cursor-pointer text-muted-foreground">Testo v{v.version}</summary><p className="whitespace-pre-wrap mt-1">{v.rules_text}</p></details>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
